import apiService from "./BaseApi";

const BASE_ENVELOPE_URL = "/envelopes"

const EnvelopeService = {
    createEnvelope: async (envelope) => apiService.post(`${BASE_ENVELOPE_URL}`, { envelope }),
    updateEnvelope: async (envelope, id) => apiService.put(`${BASE_ENVELOPE_URL}/click-sign/${id}`, { envelope }),

    getEnvelopes: async () => apiService.get(`${BASE_ENVELOPE_URL}`),
    getEnvelopeByIdFirebase: async (id) => apiService.get(`${BASE_ENVELOPE_URL}/db/${id}`),
    getEnvelopeByIdClickSign: async (id) => apiService.get(`${BASE_ENVELOPE_URL}/click-sign/${id}`),
    deleteEnvelopeByIdClickSign: async (id) => apiService.delete(`${BASE_ENVELOPE_URL}/click-sign/${id}`),

    getEventsFromEnvelope: async (id) => apiService.get(`${BASE_ENVELOPE_URL}/click-sign/${id}/events`),
    getEventsFromDocuments: async (idEnvelope, idDocument) => apiService.get(`${BASE_ENVELOPE_URL}/${idEnvelope}/${idDocument}`)
}

export default EnvelopeService;